import { forwardRef, useState } from "react";
import {
    Box,
    Dialog,
    Divider,
    Slide
} from "@mui/material";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { ReactComponent as QuestionIcon } from '../assets/question.svg';

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function HomeHelpFrequency() {
    const [open, setOpen] = useState(false);
    const openClick = () => {
        setOpen(true);
    };
    const closeClick = () => {
        setOpen(false);
    };
    return (
        <>
            <Dialog fullScreen open={open} onClose={closeClick} TransitionComponent={Transition}>
                <Box
                    sx={{
                        width: '90%',
                        textAlign: 'left',
                        padding: '30px 0 10px 10px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start'
                    }}>
                    <img src='/img/back_button_black.png' onClick={closeClick} />
                    <Box
                        sx={{
                            margin: '25px 0 0 10px',
                            fontSize: '22px'
                        }}>
                        출석 프리퀀시 안내
                    </Box>
                </Box>
                <Divider />
                <Box
                    sx={{
                        // background: '#f1f2f2',
                        margin: '20px',
                        padding: '20px',
                        borderRadius: '5px'
                    }}>
                    <Box
                        sx={{
                            fontSize: '14px'
                        }}>
                        누적 출석 횟수에 따라 보상을 주는 시스템입니다.
                        {/* <br></br>
                        <br></br>
                        20회 출석 : 두써킷 티셔츠
                        <br></br>
                        30회 출석 : 5% 할인권 + 스포츠 타올
                        <br></br>
                        40회 출석 : 스포츠 파우치
                        <br></br>
                        50회 출석 : 10% 할인권 + 스포츠 텀블러
                        <br></br>
                        60회 출석 : 엘로 손목 보호대
                        <br></br>
                        120회 출석 : 그린 손목 보호대
                        <br></br>
                        180회 출석 : 블루 손목 보호대
                        <br></br>
                        240회 출석 : 레드 손목 보호대
                        <br></br>
                        300회 출석 : 블랙 손목 보호대 */}
                    </Box>
                </Box>
                <Box
                    sx={{
                        width: '100%',
                        textAlign: 'center'
                    }}>
                    <img src='/img/use_frequency02.png'
                        style={{
                            width: '100%',
                        }} />
                </Box>
            </Dialog>

            <QuestionIcon
                style={{
                    width: '16px',
                    height: '16px',
                    position: 'absolute',
                    top: '0',
                    right: '12px',
                }}
                onClick={openClick} />
            
        </>
    )
}

export default HomeHelpFrequency;